import {
  ECountry,
  ELanguage,
  TOnboardingOpenDrawerHandlerOpenDrawerData,
} from '@portals/help-center-core';
import {
  EGoBackOption,
  GO_BACK_OPTION,
  TSearchParams,
} from '@/_types/route-params';

export const STATUS_CODES = {
  TEAPOT: 418,
};

export const CATEGORIES_PATH = '/categories';
export const CATEGORY_PATH = '/category';
export const SUBCATEGORY_PATH = '/subcategory';
export const MATERIAL_PATH = '/material';
export const SEARCH_PATH = '/search';
export const ADVICE_LIST_PATH = '/advice-list';
export const NOT_FOUND_PATH = '/not-found';
export const NOT_AVAILABLE_PATH = '/not-available';
export const TEAPOT_PATH = '/teapot'; // Нужен для secure middleware (защита от скана)

export const EXISTING_PATH_LIST = [
  CATEGORIES_PATH,
  CATEGORY_PATH,
  SUBCATEGORY_PATH,
  MATERIAL_PATH,
  SEARCH_PATH,
  ADVICE_LIST_PATH,
  NOT_AVAILABLE_PATH,
];

// Роуты, которые не требуют slug/id
export const PATHS_WITHOUT_SLUG = [
  CATEGORIES_PATH,
  ADVICE_LIST_PATH,
  NOT_AVAILABLE_PATH,
  SEARCH_PATH,
];

// Роуты, которые требуют slug/id
export const PATHS_WITH_SLUG = [CATEGORY_PATH, SUBCATEGORY_PATH, MATERIAL_PATH];

export const TELEGRAM_LINK = 'https://t.me/+izUmr6xI5Ts5OTli';
export const TELEGRAM_LINK_GLOBAL = 'https://t.me/+-l7J0l72PP82MTRi';
export const VK_LINK_GLOBAL = 'https://vk.ru/wbsellerofficial';

type TCountryParam = {
  country: ECountry;
};

export type TRouteCommon = TCountryParam & {
  locale: ELanguage;
};

export const getCategoriesRoute = ({ country }: TCountryParam): string =>
  `/${country}${CATEGORIES_PATH}`;

type TParentCategoryRouteProps = TCountryParam & {
  parentCategoryId: string;
  parentCategorySlug?: string;
};
export type TParentCategoryRouteParams = TRouteCommon &
  TParentCategoryRouteProps;

export const getParentCategoryRoute = ({
  parentCategoryId,
  country,
  parentCategorySlug,
}: TParentCategoryRouteProps): string =>
  `/${country}${CATEGORY_PATH}/${parentCategorySlug || parentCategoryId}`;

type TChildCategoryRouteProps = TCountryParam & {
  childCategoryId: string;
};

export type TChildCategoryRouteParams = TRouteCommon & TChildCategoryRouteProps;

export const getChildCategoryRoute = ({
  childCategoryId,
  country,
}: TChildCategoryRouteProps): string =>
  `/${country}${SUBCATEGORY_PATH}/${childCategoryId}`;

type TMaterialRouteProps = TCountryParam & {
  materialId: string;
  hideBackButton?: 'true' | 'false';
  materialSlug?: string;
};
export type TMaterialRouteParams = TRouteCommon & TMaterialRouteProps;

export type TAdviceListSearchParams = Record<
  keyof TOnboardingOpenDrawerHandlerOpenDrawerData,
  string | undefined
>;

export type TAdviceListRouteProps = TRouteCommon;

export const getMaterialRoute = ({
  materialId,
  country,
  materialSlug,
}: TMaterialRouteProps): string =>
  `/${country}${MATERIAL_PATH}/${materialSlug || materialId}`;

const getSearchParamsString = (params: TSearchParams): string =>
  new URLSearchParams(
    Object.entries(params).reduce<Record<string, string>>(
      (acc, [key, value]) => {
        if (value && value !== 'false') {
          acc[key] = value;
        }

        return acc;
      },
      {},
    ),
  ).toString();

type TGetUrlParams = {
  route: string;
  searchParams?: TSearchParams;
};

export const getUrl = ({ route, searchParams }: TGetUrlParams) => {
  const search = searchParams && getSearchParamsString(searchParams);

  return search ? `${route}?${search}` : route;
};

export const getSearchRoute = ({
  country,
  searchParams,
}: TCountryParam & { searchParams?: TSearchParams }): string => {
  const defaultPath = `/${country}${SEARCH_PATH}`;

  return getUrl({
    route: defaultPath,
    searchParams: {
      ...searchParams,
      [GO_BACK_OPTION]: EGoBackOption.PREV_ROUTE,
    },
  });
};

export type TMultiPageRouteParams = TParentCategoryRouteParams &
  TChildCategoryRouteParams &
  TMaterialRouteParams;
